<template>
  <div class="sky-bothinput">
    <itemSearch v-bind="$attrs">
      近
      <el-input size="medium" class="item" @change="change" v-model="val1"></el-input>天总消耗＜￥
      <el-input size="medium" class="item" @change="change" v-model="val2"></el-input>
      <div slot="toolTips">{{toolContent}}</div>
    </itemSearch>
  </div>
</template>
<script>
import itemSearch from "@/components/iglobalwin/formComponents/SkySuffix.vue";
export default {
  name: "sky-bothinput",
  props: ["value", "toolContent"],
  inheritAttrs: false,
  data() {
    return {
      val1: this.value[0] || undefined,
      val2: this.value[1] || undefined
    };
  },
  methods: {
    change(val) {
      this.$emit("input", [this.val1, this.val2]);
    }
  },
  watch: {
    value(val) {
      this.val1 = val[0];
      this.val2 = val[1];
    }
  },
  components: { itemSearch }
};
</script>
<style scoped lang="scss">
.item {
  width: 100px;
  margin: 0 10px;
}
</style>
